import styled, { css } from 'styled-components';

export const JSONWrapper = styled('div')<{ disabled?: boolean }>`
  ${({ disabled }) =>
    disabled &&
    css`
      div[class^='styles-module_insertBanner'] {
        display: none;
      }
      div[class^='styles-module_rightContainer'] {
        display: none;
      }
      div[class^='styles-module_clickNode']:has(> div[class^='styles-module_valueData']) {
        pointer-events: none;
      }
    `}
`;
